<template>
  <div v-if="initials">
    <div
      class="fe-w-m fe-h-m fe-rounded-pill fe-bg-primary-20 fe-text-sparkle-60 fe-flex fe-justify-center fe-items-center fe-text-body-xxs fe-border fe-border-primary-grey-40"
    >
      {{ initials }}
    </div>
  </div>
</template>

<script>
  export default {
    name: "UserInitialsAvatar",
    props: {
      name: {
        type: String,
        required: true,
      },
    },
    computed: {
      initials() {
        if (!this.name || typeof this.name !== "string") return null

        const words = this.name.trim().split(" ").filter(Boolean)
        return words
          .map((word) => word[0].toUpperCase())
          .slice(0, 2)
          .join("")
      },
    },
  }
</script>
